'use strict';

(function () {
    const slideShows = $('.torn-vaning-slideshow');

    uppdateraTornMenyVidScroll();
    hanteraTornmenyMobil();
    hanteraSpelaVideoLank();
    hanteraResize();

    function uppdateraTornMenyVidScroll() {
        if ('IntersectionObserver' in window) {
            const sections = document.querySelectorAll('.vaning');

            const tornVaningObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        visaAktivTornMenyLank(entry);
                        visaAktivTornVaning(entry, sections);
                        if (slideShows.length && entry.target.id !== '') {
                            spelaPausaSlideshow(entry);
                        }
                    }
                });
            }, { rootMargin: '-20% 0% -60% 0%' });

            sections.forEach(section => {
                tornVaningObserver.observe(section);
            });

            function visaAktivTornMenyLank(entry) {
                const activeLinks = document.querySelectorAll('#torn-meny a.active');
                const current = document.querySelector('#torn-meny a[href="#' + entry.target.id + '"]');

                if (current && !current.classList.contains('active')) {
                    activeLinks.forEach(item => {
                        item.classList.remove('active');
                    });
                    current.classList.add('active');
                    document.querySelector('.torn-lank-active').textContent = current.textContent;
                }
            }

            function visaAktivTornVaning(entry, sections) {
                const section = document.getElementById(entry.target.id);

                if (section && !section.classList.contains('active')) {
                    sections.forEach(item => {
                        item.classList.remove('active');
                    });
                    section.classList.add('active');
                }
            }

            function spelaPausaSlideshow(entry) {
                let slideShow = $('#' + entry.target.id);
                if (!slideShow.hasClass('torn-vaning-slideshow')) {
                    slideShow = slideShow.find('.torn-vaning-slideshow');
                }
                if (slideShow.length) {
                    slideShows.slick('slickSetOption', 'autoplay', false).slick('slickPause');
                    slideShow.slick('slickSetOption', 'autoplay', true).slick('slickPlay');
                }
            }
        }
    }

    function hanteraTornmenyMobil() {
        const screenWidth = af.getScreenWidth();
        if (screenWidth < 992) {
            const links = $('#torn-meny a');
            let menuWidth = $('#torn-meny').width();

            if (menuWidth > screenWidth) {
                menuWidth = screenWidth;
            }
            if (menuWidth < 180) {
                menuWidth = 180;
            }

            $('#navbar-torn-meny .navbar-toggler').width(menuWidth);

            $(window).on('load hashchange', function () {
                uppdateraLankText(location.hash);
            });

            links.on('click', function () {
                $('.torn-lank-active').text($(this).text());
                $('#navbar-torn-meny .navbar-toggler').click();
            })

            function uppdateraLankText(hash) {
                let active = $('#torn-meny a[href="' + hash + '"]');

                if (!active.length) {
                    active = links.first();
                }
                $('.torn-lank-active').text(active.text());
            }
        }
    }

    function hanteraSpelaVideoLank() {
        const splitBlocks = document.querySelectorAll('.vaning');
        splitBlocks.forEach(block => {
            const video = block.querySelector('video');
            const lank = block.querySelector('.spela-video-lank');
            const knapp = block.querySelector('.video-knapp');

            if (lank && video && !video.hasAttribute('autoplay')) {
                lank.addEventListener('click', e => {
                    e.preventDefault();

                    if (video.paused) {
                        video.play();
                        if (knapp) {
                            knapp.classList.add('d-none');
                        }
                    } else {
                        video.pause();
                        if (knapp) {
                            knapp.classList.remove('d-none');
                        }
                    }
                });
            }
        });
    }

    function hanteraResize() {
        window.addEventListener('resize', resizeFunctions);
    }

    function resizeFunctions() {
        hanteraTornmenyMobil();
    }

})();
